import { Logger } from 'DVWebNodeUtils'
import { tagReplacers } from 'DVWebNodeUI'
import { StringId } from '../components/localizer/stringId'
import { IStringMap, IReplaceObj } from '../selectors/string';

export type DVStringAttrs = { [key: string]: { [key: string]: string } }

type GetStringFromId = {
  strings: IStringMap
  stringId: StringId
  logger: Logger
  replace?: IReplaceObj
}

const tagRegEx = /\$?\{([^\}]+)\}/g


export const buildDvString = (string: string, attrs: DVStringAttrs = {}) => ({
  string,
  attrs
})

export const fillValues = (str?: string, replace?: IReplaceObj, logger?: Logger) => {
  if (!str) {
    return ''
  }

  const tags = str.match(tagRegEx)

  // return original string if no tags to replace
  if (!(tags && tags.length > 0)) {
    return str
  }

  // replace tags
  return tags.reduce((result, tag) => {
    const tagName = tag.replace(/\$?\{([^}|]+)([^}]+)?\}/, '$1')
    if (replace && typeof replace[tagName] !== 'undefined') {
      return result.replace(tag, replace[tagName])
    } else {
      if (!tagReplacers.includes(tagName) && logger) {
        logger.error(
          `Missing replace value for ${tag} in "${str}"`
        )
      }
      return result
    }
  }, str)
}

export const getStringFromId = ({
  strings,
  stringId,
  replace,
  logger
}: GetStringFromId) => fillValues(strings[stringId], replace, logger)


export const getStringClosure = (strings: IStringMap, logger: Logger) => (
  stringId: StringId,
  replace?: IReplaceObj
) => getStringFromId({ strings, stringId, replace, logger })
export type IGetString = ReturnType<typeof getStringClosure>
